import { useApolloClient } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { useAnalyticsContext } from "contexts/AnalyticsContext";
import { useAppDispatch } from "hooks/utilsHooks/storeHooks";
import { useCallback } from "react";
import { useIdleTimerContext } from "react-idle-timer";
import { batch } from "react-redux";
import { resetAppState } from "slices/appStateSlice";
import { refetchDishTypePrices } from "slices/dishesSlice";
import { finishOrderState } from "slices/transactionSlice";

type AwsOrderUpdate = {
	finishOrder: () => void;
};

export const useOrder = (): AwsOrderUpdate => {
	const dispatch = useAppDispatch();
	const idleTimer = useIdleTimerContext();
	const analyticsContext = useAnalyticsContext();
	const apolloClient = useApolloClient();

	const finishOrder = useCallback(() => {
		try {
			idleTimer.reset();
			analyticsContext.reset();
			batch(() => {
				dispatch(finishOrderState());
				dispatch(resetAppState());
			});
			dispatch(refetchDishTypePrices(apolloClient));
			return true;
		} catch (error) {
			Sentry.captureException(new Error(`Error while finishing order: ${error}`));
			return false;
		}
	}, [idleTimer, analyticsContext, dispatch, apolloClient]);

	return {
		finishOrder: finishOrder,
	};
};
